
export class Counter {
    counterSessionBasketKey: number;
    counterUserKey: number;
    userKey: number;
    traineeQuantity: number;

    constructor(counterSessionBasketKey: number, counterUserKey: number, userKey: number, traineeQuantity: number) {
        this.counterSessionBasketKey = counterSessionBasketKey;
        this.counterUserKey = counterUserKey;
        this.userKey = userKey;
        this.traineeQuantity = traineeQuantity;
    }
}

export class CounterTraineeQuantity {
    counterSessionBasketKey: number;
    counterUserKey: number;
    userKey: number;
    traineeQuantity: number;

    constructor(counterSessionBasketKey: number, counterUserKey: number, userKey: number, traineeQuantity: number) {
        this.counterSessionBasketKey = counterSessionBasketKey;
        this.counterUserKey = counterUserKey;
        this.userKey = userKey;
        this.traineeQuantity = traineeQuantity;
    }
}

export class SelectCounterSessionBasketOffer {
    counterSessionBasketKey: number;
    counterUserKey: number;
    userKey: number;
    isSelected: boolean;

    constructor(counterSessionBasketKey: number, counterUserKey: number, userKey: number, isSelected: boolean = true) {
        this.counterSessionBasketKey = counterSessionBasketKey;
        this.counterUserKey = counterUserKey;
        this.userKey = userKey;
    }
}

export class SelectCounterSessionBasketOfferString {
    bookingKey: number;
    counterUserKey: number;

    constructor(bookingKey: number, counterUserKey: number) {
        this.bookingKey = bookingKey;
        this.counterUserKey = counterUserKey;
    }
}


export class ResultSearchEngine {
    type: string;
    bookingKey: number;
    bookingReference: string;
    bookingRecordDate: Date;
    bookingAmount: number;
    offerKey: number;
    userKey: number;
    firstName: string;
    lastName: string;
    email: string;

    constructor(data: ResultSearchEngine) {
        this.type = data.type;
        this.bookingKey = data.bookingKey;
        this.bookingReference = data.bookingReference;
        this.bookingRecordDate = data.bookingRecordDate;
        this.bookingAmount = data.bookingAmount;
        this.offerKey = data.offerKey;
        this.userKey = data.userKey;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.email = data.email;
    }

}

export class PaymentRefundGlobal {
    paymentRefundList: PaymentRefundList[];
    totalPayment: number;
    leftToPay: number;

    constructor(data: PaymentRefundGlobal) {
        this.paymentRefundList = data.paymentRefundList || null;
        this.totalPayment = data.totalPayment || null;
        this.leftToPay = data.leftToPay || null;
    }
}
export class PaymentRefundList {
    paymentKey: number;
    amount: number;
    paymentType: string;
    paymentDate: Date;

    constructor(data: PaymentRefundList) {
        this.paymentKey = data.paymentKey || null;
        this.amount = data.amount || null;
        this.paymentType = data.paymentType || null;
        this.paymentDate = data.paymentDate || null;
    }
}

export class PaymentRefund {
    bookingKey: number;
    paymentRefundAmount: number;
    paymentTypeKey: number;
    counterUserKey: number;

    constructor(bookingKey: number, paymentRefundAmount: number, paymentTypeKey: number, counterUserKey: number) {
        this.bookingKey = bookingKey;
        this.paymentRefundAmount = paymentRefundAmount;
        this.paymentTypeKey = paymentTypeKey;
        this.counterUserKey = counterUserKey;
    }
}

export class PaymentType {
    paymentTypeKey: number;
    value: string;

    constructor(paymentTypeKey: number, value: string) {
        this.paymentTypeKey = paymentTypeKey;
        this.value = value;
    }
}

export class NewUserCounter {
    counterUserKey?: number;
    userKey?: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    address?: string;
    city?: string;
    postalCode?: string;
    country?: string;

    constructor(firstName: string, lastName: string, email: string, phoneNumber: string, address?: string, city?: string, postalCode?: string, country?: string) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email || null;
        this.phoneNumber = phoneNumber || null;
        this.address = address || null;
        this.city = city || null;
        this.postalCode = postalCode || null;
        this.country = country || null;
    }
}
